import { c as _c } from "react/compiler-runtime";
import { Logo } from "@/components/ui/logo";
import { BRAND } from "@/lib/brand";
import { cn } from "@/lib/utils";
interface WordmarkProps {
  className?: string;
  markClassName?: string;
  /** md matches the old text-xl headers, sm the sidebar menu buttons. */
  size?: "sm" | "md";
  /** Show the "by LLM Gateway" byline under the name. */
  byline?: boolean;
  /**
   * Wrap the mark in the size-8 square the sidebar menu buttons use so the
   * icon stays centered when the sidebar collapses to icon mode.
   */
  iconBox?: boolean;
}

/**
 * Renders the mark and the label as sibling elements (no wrapping span) so
 * that inside SidebarMenuButton the `[&>span:last-child]:truncate` rule only
 * ever truncates the text column, never the mark. All call sites place the
 * lockup inside a flex parent with its own gap.
 */
export function Wordmark(t0) {
  const $ = _c(22);
  const {
    className,
    markClassName,
    size: t1,
    byline: t2,
    iconBox: t3
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const byline = t2 === undefined ? true : t2;
  const iconBox = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== markClassName) {
    t4 = cn("size-6 shrink-0", markClassName);
    $[0] = markClassName;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t4) {
    t5 = <Logo className={t4} />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const mark = t5;
  let t6;
  if ($[4] !== iconBox || $[5] !== mark) {
    t6 = iconBox ? <span aria-hidden={true} className="flex aspect-square size-8 shrink-0 items-center justify-center">{mark}</span> : mark;
    $[4] = iconBox;
    $[5] = mark;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== className) {
    t7 = cn("flex min-w-0 flex-col justify-center", className);
    $[7] = className;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = size === "md" ? "text-xl" : "text-lg";
  let t9;
  if ($[9] !== t8) {
    t9 = cn("font-display font-semibold leading-none tracking-tight", t8);
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <span className={t9}>{BRAND.name}</span>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== byline) {
    t11 = byline && <span className="mt-1 whitespace-nowrap text-[9px] font-medium uppercase leading-none tracking-[0.22em] text-muted-foreground">by {BRAND.publisher}</span>;
    $[13] = byline;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11 || $[17] !== t7) {
    t12 = <span aria-label={BRAND.fullName} className={t7}>{t10}{t11}</span>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t6) {
    t13 = <>{t6}{t12}</>;
    $[19] = t12;
    $[20] = t6;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}